import { useNavigate } from "react-router-dom";
import "./ReviewService.css";

export default function ReviewService() {
  const navigate = useNavigate();

  return (
    <div className="container py-4 review-service-page">
      <h3 className="mb-3 fw-bold">Review Modes</h3>
      <div className="review-service-grid">
        <button
          type="button"
          className="review-service-card"
          onClick={() => navigate("./category")}
        >
          <div className="review-service-title">Review by system suggestion</div>
          <p className="review-service-desc mb-0">
            Hệ thống chọn thẻ đến hạn theo thuật toán.
          </p>
        </button>

        <button
          type="button"
          className="review-service-card"
          onClick={() => navigate("./category")}
        >
          <div className="review-service-title">Review by category</div>
          <p className="review-service-desc mb-0">
            Chọn category và review có chấm điểm Again/Hard/Good/Easy.
          </p>
        </button>

        <button
          type="button"
          className="review-service-card"
          onClick={() => navigate("./category-no-score")}
        >
          <div className="review-service-title">Review by category no score</div>
          <p className="review-service-desc mb-0">
            Chọn category, lấy tối đa 50 thẻ và ôn bằng Previous/Next.
          </p>
        </button>
      </div>
    </div>
  );
}
